import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, "What kind of task do you want to create?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: "0"
}, "Select your task type", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "simpleTask" }, "Simple Task", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "form" }, "Form", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "scheduling" }, "Scheduling", -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: "0"
}, "Select your form", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "addForm" }, "[Add a form]", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: "0"
}, "Select your schedule", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "hubspot" }, "Hubspot", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "calendly" }, "Calendly", -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "mb-3 mt-3"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#addFormModal",
  ref: "openFormModal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("select", {
      class: "form-select mb-2",
      "aria-label": "select task type",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTaskType) = $event))
    }, _hoisted_6, 512), [
      [_vModelSelect, _ctx.selectedTaskType]
    ]),
    (_ctx.selectedTaskType==='form')
      ? _withDirectives((_openBlock(), _createElementBlock("select", {
          key: 0,
          class: "form-select",
          "aria-label": "select task type",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedForm) = $event))
        }, [
          _hoisted_7,
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (form) => {
            return (_openBlock(), _createElementBlock("option", {
              key: form.formId,
              value: form.formId
            }, _toDisplayString(form.name), 9, _hoisted_9))
          }), 128))
        ], 512)), [
          [_vModelSelect, _ctx.selectedForm]
        ])
      : _createCommentVNode("", true),
    (_ctx.selectedTaskType==='scheduling')
      ? _withDirectives((_openBlock(), _createElementBlock("select", {
          key: 1,
          class: "form-select",
          "aria-label": "select task type",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSchedule) = $event))
        }, _hoisted_13, 512)), [
          [_vModelSelect, _ctx.selectedSchedule]
        ])
      : _createCommentVNode("", true),
    (_ctx.scheduleType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createTextVNode(" Enter your " + _toDisplayString(_ctx.scheduleType) + " calendar link: ", 1),
          _withDirectives(_createElementVNode("input", {
            class: "form-control mt-1",
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.scheduleLink) = $event)),
            placeholder: "https://",
            onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.scheduleLink]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary mt-2",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
            disabled: _ctx.submitted || !_ctx.scheduleLink.length
          }, _toDisplayString(_ctx.submitted ? "Creating" : "Create Task"), 9, _hoisted_15)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("button", _hoisted_16, "Open", 512), [
      [_vShow, false]
    ])
  ]))
}